import { useMemo } from 'react'
import { useFormState } from 'react-final-form'
import { doNotTranslate } from 'util/misc'
import { Alert } from 'opensolar-ui'
import { FilterStruct } from '../../conditions/types'

const CUSTOMER_WARNING_STRUCT_TYPES: readonly string[] = [
  'promo-dialog',
  'toast-notification',
  'banner-ad',
  'page-takeover-ad',
]
const UNAUTH_WARNING_STRUCT_TYPES: readonly string[] = ['promo-dialog', 'toast-notification']
const AUTH_PREFIXES = ['org.', 'role.', 'user.']

function isProOnlyGroup(group: FilterStruct): boolean {
  return group.conditions.some(
    (c) =>
      (!c.value && c.op === 'eq' && c.path === 'auth.is_customer') ||
      (c.value && c.op === 'eq' && c.path === 'auth.is_pro')
  )
}

function hasAuthenticatedCondition(group: FilterStruct): boolean {
  return group.conditions.some((c) => AUTH_PREFIXES.some((prefix) => c.path && c.path.startsWith(prefix)))
}

export const StandardConditionWarnings = () => {
  const { values } = useFormState()
  const structType: string | undefined = values.type
  const conditions: FilterStruct[] | undefined = values.data?.conditions

  const showCustomerWarning = useMemo(() => {
    if (!structType || !CUSTOMER_WARNING_STRUCT_TYPES.includes(structType)) return false
    if (!conditions || conditions.length === 0) return true
    return conditions.some((group) => !isProOnlyGroup(group))
  }, [structType, conditions])

  const showUnauthWarning = useMemo(() => {
    if (!structType || !UNAUTH_WARNING_STRUCT_TYPES.includes(structType)) return false
    if (!conditions || conditions.length === 0) return true
    return conditions.some((group) => !hasAuthenticatedCondition(group))
  }, [structType, conditions])

  if (!showCustomerWarning && !showUnauthWarning) return null

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {showCustomerWarning && (
        <Alert severity="warning">
          {doNotTranslate(
            'This content can be shown to customers. To restrict to pros only, add a condition such as Is Customer = false or Is Pro = true in the Conditions section.'
          )}
        </Alert>
      )}
      {showUnauthWarning && (
        <Alert severity="warning">
          {doNotTranslate(
            'This content can be shown to unauthenticated users (e.g. on login, registration or expo). To avoid that, add a condition from the Org, Role, or User category (e.g. Org Country, Role ID, User ID).'
          )}
        </Alert>
      )}
    </div>
  )
}
